module.exports = __webpack_public_path__ + "static/media/discussion.5b9805f6.jpg";